import {
  call, put, takeLatest, select,
} from 'redux-saga/effects';

import {
  GET_TIPOLOGIAS_REQUEST,
} from '../../actions/constants/tipologias/tipologias.constants';
import { authRequest } from '../../../helpers/request.helper';
import {
  getTipologiasFailureAction,
  getTipologiasSuccessAction,
} from '../../actions/creators/tipologias/tipologias.actioncreator';

const getTipologiasFromState = state => state.tipologias;

function* getTipologias(action) {
  const { payload } = action;
  const {
    page, start, limit, filter,
  } = payload;
  if (filter !== null) {
    const params = {
      url: `tipologias/?page=${page}&start=${start}&limit=${limit}&filter=${JSON.stringify(filter)}`,
      method: 'GET',
    };

    try {
      const response = yield call(authRequest, params);
      const { datos, success, total } = response;
      if (success) {
        const tipologiasFromState = yield select(getTipologiasFromState);

        yield put(getTipologiasSuccessAction(datos, total, page, start, limit));
      } else {
        yield put(getTipologiasFailureAction());
      }
    } catch (error) {
      yield put(getTipologiasFailureAction(error));
    }
  }
}

export function* getTipologiasRequest() {
  yield takeLatest(GET_TIPOLOGIAS_REQUEST, getTipologias);
}
